import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../../Redux";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import { useHistory } from "react-router-dom";

const PromotionsSalesData = (props) => {
  // console.log(props.location.state, "lllllllllll");
  const history = useHistory();
  const dispatch = useDispatch();
  const promotionsSalesData = useSelector(
    (state) => state?.financeReducer?.promotionsSalesData
  );
  console.log(promotionsSalesData, "promotionsSalesData");

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  <div className="field text-right my-3 pt-1 px-0">
                    <button
                      onClick={() => history.goBack()}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to promotions
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <h4 class="event-alert">
                            Items{" "}
                            <p class="billno-right">
                              {" "}
                              USAGE #{promotionsSalesData?.promotion_id}
                            </p>
                          </h4>

                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12"></div>
                            <div class="col-sm-auto text-small align-right col-12 mt-2 mt-sm-0">
                              <i>
                                Last Upload {promotionsSalesData?.last_update}
                              </i>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Promotion Item Usage ID</th>
                                    <th>Item #</th>
                                    <th>Promotion Name</th>
                                    <th>Item Name</th>
                                    <th>Quantity</th>
                                    <th>Promotion Type</th>
                                    <th>Original Price</th>
                                    <th>Promo Price</th>
                                    <th>Promo Discount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {promotionsSalesData?.items?.map((el) => (
                                    <tr>
                                      <td>{el?.pos_promotion_use?.id}</td>
                                      <td>{el?.menu_item?.id}</td>
                                      <td>
                                        {el?.pos_promotion_use?.promotion_name}
                                      </td>
                                      <td>{el?.menu_item?.menu_item_name}</td>
                                      <td>{el?.quantity}</td>
                                      <td>{el?.pos_promotion_use?.type}</td>
                                      <td>{el?.original_price}</td>
                                      <td>{el?.promo_price}</td>
                                      <td>{el?.promo_discount}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default PromotionsSalesData;
